import type { PresetModel } from "@defibrillator/preset-core";
import {
  DEFAULT_VITAL_TARGET_VERSION,
  type VitalTargetVersion,
} from "@defibrillator/vital-adapter";
import { emitVitalText } from "@defibrillator/vital-adapter/emit";

function safeFilename(name: string): string {
  const base = name.trim().replace(/[^\w .,'\-()+]+/gu, "_").slice(0, 64) || "preset";
  return base.endsWith(".vital") ? base : `${base}.vital`;
}

/** Client-side `.vital` download — no R2 or renderer. */
export function downloadVital(
  model: PresetModel,
  targetVersion: VitalTargetVersion = DEFAULT_VITAL_TARGET_VERSION,
): void {
  const text = emitVitalText(model, { targetVersion });
  const blob = new Blob([text], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = safeFilename(model.name);
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
